import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { hasAuthKey } from '../../utils/api/auth-utils';

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
        {...rest}
        render={props =>
            hasAuthKey() ? (
                // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
                <Component {...props} />
            ) : (
                <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            )
        }
    />
);

export default PrivateRoute;
